module.exports = __webpack_public_path__ + "img/character_a.eec011f8.svg";